import React from 'react';
import { Col, Image } from 'react-bootstrap';
import _ from 'lodash';
const currentYear = new Date().getFullYear()
const FreezeColumn = ({ title, currentInstitution }) => (
  <Col
    xs={12}
    md={3}
    className="center-block text-center d-flex flex-column justify-content-center freeze-column"
  >
    <div className="p-2">
      <Image
        src={_.get(currentInstitution, 'logo._url')}
        alt={_.get(currentInstitution, 'name')}
        className="institution-logo pb-2"
      />
    </div>
    <div className="p-2">
      <h4>{title}</h4>
      <h3>{currentYear}</h3>
    </div>
    <div className="p-2" />
  </Col>
);

export default FreezeColumn;
